import { render } from "./BrandLogoSupIzq.vue?vue&type=template&id=094c7dd6"
import script from "./BrandLogoSupIzq.vue?vue&type=script&lang=js"
export * from "./BrandLogoSupIzq.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__